import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ModalAddressForm from 'modules/shipper-order/Form/fields/ModalAddressForm';

import { withFormikField, getFormikError } from 'utils/formik';

import { setCheckTimes } from 'redux/modules/shipper-order-new/duck';

import {
  CustomSelect,
  IconRenderer,
  OptionComponent,
  ValueRenderer,
  NoResultsComponent,
} from './styled';
import { connect } from 'react-redux';

const mapAddresses = (address) => {
  const { zipcode, city, company_name } = address;
  return {
    value: address,
    label: `${company_name} - ${zipcode} ${city}`,
    visibleLabel: `${company_name}`,
    labelHelp: `${zipcode} ${city}`,
  };
};

const t = {
  add_address: 'Add address',
  add_new_address: 'Create new address',
  save_address: 'Save address',
  no_addresses: 'No addresses',
};

class AddressSelector extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    placeholder: PropTypes.any,
    addresses: PropTypes.array,
    onSaveAddress: PropTypes.func,
    zipcodeRE: PropTypes.string,
    form: PropTypes.object.isRequired,
    field: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      modalOpened: false,
    };
    this.defaultOption = [
      {
        value: false,
        label: t.add_new_address,
        action: () => this.openNewAddress(),
      },
    ];
  }

  openNewAddress = (
    cb = () => {
      /*noop*/
    }
  ) => {
    this.setState(
      {
        modalOpened: true,
      },
      cb
    );
  };

  closeNewAddress = (cb) => {
    this.setState(
      {
        modalOpened: false,
      },
      cb
    );
  };

  handleChange = (option) => {
    const { field, form, onChange, setCheckTimes } = this.props;

    const { action } = option || {};
    if (action) {
      action();
      return;
    }

    const { setFieldValue } = form;

    if (setFieldValue && option) {
      setFieldValue(field.name, option.value);
      setCheckTimes(true);
      if (onChange) {
        onChange(option.value);
      }
    }
  };

  focusInput = () => {
    const { addresses = [] } = this.props;

    if (addresses.length === 0) {
      this.openNewAddress();
    }
  };

  render() {
    const { placeholder, addresses = [], onSaveAddress, field, form, disabled } = this.props;

    const { modalOpened } = this.state;

    const { value } = field;
    const rawAddress = value && typeof value === 'object' ? value : null;
    const finalAddresses = rawAddress ? [rawAddress].concat(addresses) : addresses;

    return (
      <div>
        <CustomSelect
          placeholder={placeholder}
          ignoreCase={true}
          matchPos="any"
          value={value}
          valueKey="id"
          clearable={false}
          small
          autosize={false}
          multi={false}
          openOnFocus={addresses.length > 0}
          onFocus={this.focusInput}
          valueRenderer={ValueRenderer}
          optionComponent={OptionComponent}
          noResultsText={
            <NoResultsComponent
              text={t.no_addresses}
              addText={t.add_new_address}
              onAddClick={() => this.openNewAddress()}
            />
          }
          arrowRenderer={IconRenderer}
          options={this.defaultOption.concat(finalAddresses.map(mapAddresses))}
          onBlurResetsInput={true}
          onChange={this.handleChange}
          scrollMenuIntoView={true}
          invalid={!!getFormikError({ field, form })}
          disabled={disabled}
        />
        {modalOpened ? (
          <ModalAddressForm
            title={t.add_address}
            call2action={t.save_address}
            show={modalOpened}
            defaultZip={null}
            onSave={(address) =>
              new Promise((resolve) => {
                resolve();
                this.closeNewAddress();
                this.handleChange({ value: address });
                onSaveAddress({
                  ...address,
                  isNew: true,
                });
              })
            }
            onClose={() => this.closeNewAddress()}
          />
        ) : null}
      </div>
    );
  }
}

const actionCreators = {
  setCheckTimes,
};

export default connect((_) => ({}), actionCreators)(withFormikField(AddressSelector));
